import React from "react";
import { Button, Dialog, Link } from "@sscs/ui";
import { STORE_PACKAGE_ID, STORE_PROJECT_ID } from "Constants";
import { useAppDispatch, useProjectsRoute } from "Hooks";
import { clearAllProjectData } from "Store/projects.slice";

const ProjectDeletedContent = (): React.JSX.Element => {
  const projectsRoute = useProjectsRoute();
  const dispatch = useAppDispatch();

  return (
    <>
      <Dialog.Header>
        <Dialog.Header.Title>Project deleted</Dialog.Header.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Dialog.Section>
          <Dialog.Section.Content>
            <p>This project has been deleted by another user.</p>
          </Dialog.Section.Content>
        </Dialog.Section>
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Footer.Actions>
          <Link
            to={projectsRoute}
            onClick={() => {
              localStorage.removeItem(STORE_PROJECT_ID);
              localStorage.removeItem(STORE_PACKAGE_ID);
              dispatch(clearAllProjectData());
            }}
            underline="none"
          >
            <Button>Return to projects</Button>
          </Link>
        </Dialog.Footer.Actions>
      </Dialog.Footer>
    </>
  );
};

type ProjectDeletedProps = {
  isOpen: boolean;
};

const ProjectDeleted = ({ isOpen }: ProjectDeletedProps): React.JSX.Element => (
  <Dialog.Frame size="xs" isOpen={isOpen}>
    <ProjectDeletedContent />
  </Dialog.Frame>
);

export default ProjectDeleted;
